const SOUND_FILES_ROOT = "SoundFiles";
const AREA_FILES_ROOT = "AreaFiles";

export const getLegacySoundFilePath = () => SOUND_FILES_ROOT;

export const getAreaSoundFilePath = (areaId?: string) => {
    const trimmedAreaId = (areaId || "").trim();
    return trimmedAreaId ? `${SOUND_FILES_ROOT}/${trimmedAreaId}` : SOUND_FILES_ROOT;
};

export const getTransitionUploadPaths = (areaId?: string) => {
    return Array.from(new Set([
        getLegacySoundFilePath(),
        getAreaSoundFilePath(areaId)
    ]));
};

export const getTransitionStoredFilePaths = (areaId?: string, filePath?: string) => {
    return Array.from(new Set([
        filePath || getAreaSoundFilePath(areaId),
        getLegacySoundFilePath(),
        getAreaSoundFilePath(areaId)
    ]));
};

export const buildAreaAssetApiPath = (storageObjectPath: string) => {
    return `/assets?path=${encodeURIComponent(storageObjectPath)}`;
};

export const getAreaCoverImagePath = (areaId?: string) => {
    const trimmedAreaId = (areaId || "").trim();
    return trimmedAreaId ? `${AREA_FILES_ROOT}/${trimmedAreaId}/CoverImages` : `${AREA_FILES_ROOT}/CoverImages`;
};

export const buildAreaCoverImageApiPath = (storageObjectPath: string) => buildAreaAssetApiPath(storageObjectPath);

export const getSpotCoverImagePath = (areaId?: string, spotKey?: string) => {
    const trimmedAreaId = (areaId || "").trim();
    const trimmedSpotKey = (spotKey || "").trim();
    if (!trimmedAreaId || !trimmedSpotKey) {
        return AREA_FILES_ROOT;
    }
    return `${AREA_FILES_ROOT}/${trimmedAreaId}/SpotImages/${trimmedSpotKey}`;
};

export const buildSpotCoverImageApiPath = (storageObjectPath: string) => buildAreaAssetApiPath(storageObjectPath);
